module.exports = __webpack_public_path__ + "img/744.8534f68e.jpg";